import { cloneDeep } from "lodash";
import { UPDATE_CONNECTION_VALUE_ERROR, 
    UPDATE_CONNECTION_VALUE_STARTING, 
    UPDATE_CONNECTION_VALUE_SUCCESS
 } from "../../../constants/actionTypes";
import initialState from "../../../store/initialState";

export default function updateConnectionValueReducer(state = initialState.updateConnectionValue, action) {
    switch (action.type) {
        case UPDATE_CONNECTION_VALUE_STARTING: {
            const { connectionValueId } = action;
            const newState = cloneDeep(state);
            if (!newState[connectionValueId]) {
                newState[connectionValueId] = cloneDeep(initialState.updateConnectionValue.connectionValueId);
            }
            const connectionData = newState[connectionValueId];
            connectionData.saving = true;
            connectionData.saved = false;
            connectionData.error = null;

            return newState;
        }
        case UPDATE_CONNECTION_VALUE_SUCCESS: {
            const { connectionValueId } = action;
            const newState = cloneDeep(state);
            if (!newState[connectionValueId]) {
                newState[connectionValueId] = cloneDeep(initialState.updateConnectionValue.connectionValueId);
            }

            const connectionData = newState[connectionValueId];
            connectionData.saving = false;
            connectionData.saved = true;
            connectionData.error = null;
            return newState;
        }

        case UPDATE_CONNECTION_VALUE_ERROR: {
            const { connectionValueId } = action;
            const newState = cloneDeep(state);

            if (!newState[connectionValueId]) {
                newState[connectionValueId] = cloneDeep(initialState.updateConnectionValue.connectionValueId);
            }

            const connectionData = newState[connectionValueId];
            connectionData.saving = false;
            connectionData.saved = false;
            connectionData.error = action.err;
            return newState;
        }
        default: {
            return state;
        }
    }
}